import { render } from "./PauseButton.vue?vue&type=template&id=de167b56&scoped=true"
import script from "./PauseButton.vue?vue&type=script&lang=js"
export * from "./PauseButton.vue?vue&type=script&lang=js"

import "./PauseButton.vue?vue&type=style&index=0&id=de167b56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de167b56"]])

export default __exports__